import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import Header from 'src/shared/components/Header';
import Footer from 'src/shared/components/Footer';
import { ErrorBoundary } from 'src/shared/components/ErrorBoundary';
import PageLoader from "src/shared/components/layout/PageLoader/PageLoader";
import Page404 from "./pages/404Page";

const HomePage = lazy(() => import('./pages/HomePage'));
const TourPage = lazy(() => import('./pages/TourPage'));
const BookingPage = lazy(() => import('./pages/BookingPage'));
const LegalPage = lazy(() => import('./pages/LegalPage'));
const SuccessPage = lazy(() => import('./pages/SuccessPage'));

function App() {
    return (
        <Router>
            <ErrorBoundary>
                <div className="App">
                    <Header/>
                    <Suspense fallback={<PageLoader />}>
                        <Routes>
                            <Route path="/" element={<HomePage />}/>
                            <Route path="/tour/:id" element={<TourPage />}/>
                            <Route path="/booking/:id" element={<BookingPage />}/>
                            <Route path="/success" element={<SuccessPage />}/>
                            <Route path="/legal" element={<LegalPage />}/>
                            <Route path="*" element={<Page404 />}/>
                        </Routes>
                    </Suspense>
                    <Footer/>
                </div>
            </ErrorBoundary>
        </Router>
    );
}

export default App;
